import { Box, Button, FormControlLabel, Switch } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
export var AncillaryMenuOption = function AncillaryMenuOption(_ref) {
  var onClick = _ref.onClick,
      startIcon = _ref.startIcon,
      text = _ref.text;
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      color: function color(t) {
        return t.palette.common.black;
      },
      p: 1
    },
    "data-element": "Box",
    "data-component": "AncillaryMenuOption",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(Button, {
      sx: {
        width: '100%',
        justifyContent: 'left',
        fontSize: '16px',
        fontWeight: 400
      },
      color: "inherit",
      onClick: onClick,
      startIcon: startIcon,
      "data-element": "Button",
      "data-component": "AncillaryMenuOption",
      "data-source-file": "index.tsx",
      children: text
    })
  });
};
export var AncillaryMenuSwitchOption = function AncillaryMenuSwitchOption(_ref2) {
  var checked = _ref2.checked,
      onClick = _ref2.onClick,
      text = _ref2.text;
  return /*#__PURE__*/_jsx(FormControlLabel, {
    color: "inherit",
    sx: {
      width: 1,
      py: 1.5,
      justifyContent: 'start'
    },
    control: /*#__PURE__*/_jsx(Switch, {
      checked: checked
    }),
    label: text,
    onClick: onClick,
    "data-element": "FormControlLabel",
    "data-component": "AncillaryMenuSwitchOption",
    "data-source-file": "index.tsx"
  });
};